"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvatar = void 0;
var _male = _interopRequireDefault(require("./resources/male.svg"));
var _female = _interopRequireDefault(require("./resources/female.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getAvatar = _ref => {
  let {
    firstName = '',
    lastName = '',
    avatarUrl,
    gender = 'male',
    withDefaultImage = true,
    startBy = 'FirstName'
  } = _ref;
  let avatar = '';
  let initials = '';
  if (avatarUrl) {
    avatar = avatarUrl;
  } else if (withDefaultImage) {
    avatar = gender === 'female' ? _female.default : _male.default;
  } else {
    initials = startBy === 'FirstName' ? firstName.slice(0, 1) + lastName.slice(0, 1) : lastName.slice(0, 1) + firstName.slice(0, 1);
  }
  return {
    avatar,
    initials
  };
};
exports.getAvatar = getAvatar;